import { render, staticRenderFns } from "./MarkCard.vue?vue&type=template&id=278e5e04&scoped=true&"
import script from "./MarkCard.vue?vue&type=script&lang=js&"
export * from "./MarkCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e5e04",
  null
  
)

export default component.exports